import Vue from 'vue';
import VueYoutube from 'vue-youtube';
import VueCollapse from 'vue2-collapse/src/index';
import axios from 'axios';
import router from '@/router/router.js';
import VueGtag from 'vue-gtag';

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';

import agenda from '@/components/agenda/agenda';
import agendaOverview from '@/components/agenda/agenda-overview';
import bankMembers from '@/components/members/bank-members';
import DetectDevice from '@/helpers/detect.device.js';
import emblem from '@/components/emblem';
import groupMemberCards from '@/components/members/group-member-cards';
import legislationMonitor from '@/components/legislationMonitor/legislation-monitor';
import legislationUpdateCard from '@/components/legislationMonitor/legislation-update-card';
import legislationSubjects from '@/components/legislationMonitor/legislation-subjects';
import legislationDetail from '@/components/legislationMonitor/legislation-detail/legislation-detail';
import relatedLegislations from '@/components/legislationMonitor/legislation-detail/related-legislations';
import meetingCard from '@/components/meetingGroup/meeting-card';
import meetingMember from '@/components/meetingGroup/meeting-member';
import meetingOverview from '@/components/meeting/meeting-overview';
import memberInfo from '@/components/members/member-info';
import memberOverview from '@/components/members/member-overview';
import memberSlider from '@/components/members/member-slider';
import navigation from '@/components/navigation/navigation.js';
import profileData from '@/components/profile/profile-data';
import profileOverview from '@/components/profile/profile-overview';
import profileSettings from '@/components/profile/profile-settings';
import themeUpdates from '@/components/updates/theme-updates';
import myLatestUpdates from '@/components/updates/my-latest-updates';
import roadMap from '@/components/roadmap/roadmap';

//components
import '@/components/blocks/block.contact.js';
import '@/components/blocks/block.video.js';
import '@/components/blocks/image.slider.js';
import '@/components/blocks/login-block.js';
import '@/components/blocks/search.block.js';
import '@/components/cookiebar.js';
import '@/components/grid/slider.item.js';
import '@/components/grid/twitter.item.js';
import '@/components/grid/video.item.js';
import '@/components/overview/overview.block.js';
import '@/components/overview/overview.filter.block.js';
import '@/components/overview/overview.filtercat.block.js';
import '@/components/overview/overview.filternewsmembers.block.js';
import '@/components/overview/overview.news.block.js';
import '@/components/pressRelease/pressrelease.cancel.js';
import '@/components/pressRelease/pressrelease.confirm.cancellation.js';
import '@/components/pressRelease/pressrelease.signup.js';
import '@/components/sidebar.scroll.js';

//import plugins
import { Select, Option, Form, Collapse, CollapseItem } from 'element-ui';
Vue.use(Select);
Vue.use(Option);
Vue.use(Form);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(VueYoutube);
Vue.use(VueCollapse);

import '@/scss/main.scss';

import sentry from '@/plugins/sentry';
sentry.init(window.settings.environment, window.settings.sentryDSN);

Vue.config.productionTip = false;

Vue.filter('capitalize', function(value) {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
});

import formHelper from './helpers/formHelper';

import nl from 'vee-validate/dist/locale/nl';
import VeeValidate, { Validator } from 'vee-validate';

Vue.use(VeeValidate);
Validator.localize('nl', nl);

Vue.use(VueGtag, {
    config: { id: 'UA-16917319-29' }
});

window.app = new Vue({
    el: '#app',
    router,
    components: {
        agenda,
        agendaOverview,
        bankMembers,
        emblem,
        groupMemberCards,
        legislationMonitor,
        legislationUpdateCard,
        legislationSubjects,
        legislationDetail,
        relatedLegislations,
        meetingCard,
        meetingMember,
        meetingOverview,
        memberInfo,
        memberOverview,
        memberSlider,
        myLatestUpdates,
        roadMap,
        navigation,
        profileData,
        profileOverview,
        profileSettings,
        themeUpdates
    },

    data() {
        return {
            agent: null,
            mobile: false,
            settings: {}
        };
    },

    created() {
        const device = new DetectDevice();
        device.init();
        this.agent = device.agent;
        this.mobile = device.agent.mobile() != null;
        this.settings = window.settings;

        this.setGlobalAxiosSettings();
    },

    mounted() {
        document.body.addEventListener('touchstart', function() {});
        const homepageBlockImageElements = document.getElementsByClassName(
            'homepage-block-image'
        );
        for (
            let index = 0;
            index < homepageBlockImageElements.length;
            index++
        ) {
            const element = homepageBlockImageElements[index];
            const elementWidth = element.clientWidth;
            if (elementWidth < 500) {
                const smallImage = element.dataset.smallImage;
                element.style.backgroundImage = `url('${smallImage}')`;
            } else {
                const largeImage = element.dataset.largeImage;
                element.style.backgroundImage = `url('${largeImage}')`;
            }
        }
    },

    methods: {
        resetAffixPosition() {
            const scrollPos = document.documentElement.scrollTop;

            setTimeout(() => {
                document.documentElement.scrollTop = scrollPos + 1;
            }, 250);
        },
        setGlobalAxiosSettings() {
            const antiforgeryToken = formHelper.getAntiforgeryToken();
            axios.defaults.headers.post[
                'RequestVerificationToken'
            ] = antiforgeryToken;

            axios.defaults.headers.delete[
                'RequestVerificationToken'
            ] = antiforgeryToken;
        }
    }
});
